import type { ReactNode } from 'react'

interface AdminModalProps {
  title: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  wide?: boolean
}

export function AdminModal({ title, onClose, children, footer, wide }: AdminModalProps) {
  return (
    <div
      className="fixed inset-0 z-[600] flex items-center justify-center p-6"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/40" />
      <div
        className={`relative z-[1] bg-surface rounded-[14px] border border-line-soft shadow-[0_8px_40px_rgba(0,0,0,0.18)] max-h-[90vh] overflow-y-auto flex flex-col ${wide ? 'w-[640px]' : 'w-[480px]'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 pt-5 pb-3 border-b border-line-soft shrink-0">
          <h2 className="m-0 text-[18px] font-bold">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="bg-transparent border-0 text-[22px] cursor-pointer text-muted leading-none"
          >
            ×
          </button>
        </div>
        <div className="px-6 py-5 flex flex-col gap-4">{children}</div>
        {footer && (
          <div className="px-6 py-4 border-t border-line-soft flex justify-end gap-2 shrink-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}

export function adminFieldClass() {
  return 'w-full px-3 py-2 rounded-lg border border-line-soft bg-bg text-[14px] font-sans box-border'
}

export function toDatetimeLocal(iso: string): string {
  const d = new Date(iso)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function fromDatetimeLocal(value: string): string {
  return new Date(value).toISOString()
}
